import React from "react";
import { WEBSITE_BUILDER_Z_LAYERS } from "../../../../utility/websiteBuilderZLayers";
import { IWebsiteBuilderSectionEntityViewBoundingBox } from "../../hooks/sectionEntity/helpers/sectionEntityViewBoundingBox";

interface ISectionEntityFrameSelectedProps {
  selected: boolean;
  boundingBox: IWebsiteBuilderSectionEntityViewBoundingBox;
}

export function SectionEntityFrameSelection(props: ISectionEntityFrameSelectedProps) {
  const { selected, boundingBox } = props;

  return (
    <>
      {selected && (
        <div
          className="website-builder-section-entity-frame-selection"
          style={{
            left: boundingBox.x,
            top: boundingBox.y,
            width: boundingBox.width,
            height: boundingBox.height,
            zIndex: WEBSITE_BUILDER_Z_LAYERS.designSpace.sectionEntityFrame,
          }}
        />
      )}
    </>
  );
}
